import React from 'react';
import { ACTIVITY_TYPES } from '../../platform/store/useOperationalStore';
import { fmtTs, parseLegacyText } from './roHelpers';
import { PhotoThumb } from './PhotoViewer';

export default function ActivityItem({ activity, onPhotoExpand }) {
  const { type, text, author, timestamp, photos, customerFacing, category } = activity;
  const { text: displayText, photoKey: legacyPhoto } = parseLegacyText(text);

  const meta = (
    <div className="ro-act-meta">
      {author && <span className="ro-act-author">{author}</span>}
      {timestamp && <span className="ro-act-time">{fmtTs(timestamp)}</span>}
    </div>
  );

  if (type === ACTIVITY_TYPES.STATUS_CHANGE) {
    return (
      <div className="ro-act ro-act--system">
        <span className="ro-act-system-dot" />
        <span>{displayText || 'Stage changed'}</span>
        {author && <span className="ro-act-time">{author} · {fmtTs(timestamp)}</span>}
      </div>
    );
  }

  if (type === ACTIVITY_TYPES.BLOCKER_SET) {
    return (
      <div className="ro-act ro-act--blocker-set">
        <div className="ro-act-icon">⛔</div>
        <div className="ro-act-body">
          <div className="ro-act-label">Blocked</div>
          <div className="ro-act-text">{displayText}</div>
          {meta}
        </div>
      </div>
    );
  }

  if (type === ACTIVITY_TYPES.BLOCKER_CLEARED) {
    return (
      <div className="ro-act ro-act--blocker-clear">
        <div className="ro-act-icon">✓</div>
        <div className="ro-act-body">
          <div className="ro-act-label">Unblocked</div>
          <div className="ro-act-text">{displayText}</div>
          {meta}
        </div>
      </div>
    );
  }

  if (type === ACTIVITY_TYPES.FINDING) {
    return (
      <div className="ro-act ro-act--finding">
        <div className="ro-act-header">
          <span className="ro-act-type-badge">Finding</span>
          {category && <span className="ro-act-category">{category}</span>}
          <span className={`ro-act-facing ${customerFacing ? 'facing-customer' : 'facing-internal'}`}>
            {customerFacing ? 'Customer-Facing' : 'Internal'}
          </span>
        </div>
        <div className="ro-act-text">{displayText}</div>
        {(photos?.length > 0 || legacyPhoto) && (
          <div className="ro-act-photos">
            {legacyPhoto && <PhotoThumb photoKey={legacyPhoto} onExpand={onPhotoExpand} />}
            {(photos || []).map(k => <PhotoThumb key={k} photoKey={k} onExpand={onPhotoExpand} />)}
          </div>
        )}
        {meta}
      </div>
    );
  }

  if (type === ACTIVITY_TYPES.REPAIR) {
    return (
      <div className="ro-act ro-act--repair">
        <div className="ro-act-header">
          <span className="ro-act-type-badge">Repair Performed</span>
          {category && <span className="ro-act-category">{category}</span>}
        </div>
        <div className="ro-act-text">{displayText}</div>
        {(photos?.length > 0 || legacyPhoto) && (
          <div className="ro-act-photos">
            {legacyPhoto && <PhotoThumb photoKey={legacyPhoto} onExpand={onPhotoExpand} />}
            {(photos || []).map(k => <PhotoThumb key={k} photoKey={k} onExpand={onPhotoExpand} />)}
          </div>
        )}
        {meta}
      </div>
    );
  }

  if (type === ACTIVITY_TYPES.AUTHORIZATION) {
    return (
      <div className="ro-act ro-act--auth">
        <div className="ro-act-header">
          <span className="ro-act-type-badge">Authorization</span>
        </div>
        <div className="ro-act-text">{displayText}</div>
        {meta}
      </div>
    );
  }

  // Default: note / photo / customer_update
  return (
    <div className="ro-act ro-act--note">
      {displayText && <div className="ro-act-text">{displayText}</div>}
      {(photos?.length > 0 || legacyPhoto) && (
        <div className="ro-act-photos">
          {legacyPhoto && <PhotoThumb photoKey={legacyPhoto} onExpand={onPhotoExpand} />}
          {(photos || []).map(k => <PhotoThumb key={k} photoKey={k} onExpand={onPhotoExpand} />)}
        </div>
      )}
      {meta}
    </div>
  );
}
